import axios from 'axios';
import apiPath from './apiPath';

const api = {
  GetDeliverySetting() {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_GLOBAL_SETTING_DELIVERY.path
      }`,
      method: 'get'
    });
  },

  CreatedDeliverySetting(payload) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_GLOBAL_SETTING_DELIVERY.path
      }`,
      method: 'post',
      data: payload
    });
  }
};

export default api;
